import CustomButton from "@/components/common/Button";
import { notify } from "@/components/common/Notification";
import { DynamicModuleService, DropdownService } from "@/services/APIs";
import { ProColumns } from "@ant-design/pro-components";
import { Popconfirm } from "antd";
import { Edit2, Plus, Trash } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import ConfigDynamicTable from "../../../../components/BaseTable/ConfigDynamicTable";
import HRMSNavigationRoutes from "../../utils/navigationRoutes";

const EmployeeLifecycleListPage = () => {
  const navigate = useNavigate();
  const schemaEmployeeOnboardingTemplate = "employee Onboarding Template hrms";
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const { data: designationRaw } = useQuery({
    queryKey: ["dropdown", "Designation"],
    queryFn: () => DropdownService.getDropdownData("Designation"),
  });
  const queryClient = useQueryClient();

  const designationOptions: any[] = Array.isArray(designationRaw)
    ? designationRaw
    : (designationRaw?.results ?? designationRaw?.data ?? []);

  const findLabel = (list: any[], val: any) => {
    if (val === null || val === undefined) {
      return "";
    }
    return (
      list.find(
        (o: any) =>
          o?.value === val || o?.id === val || o?.key === val || o?.pk === val
      )?.label ??
      list.find((o: any) => o?.value === val || o?.id === val || o?.key === val)
        ?.name ??
      val
    );
  };

  const handleDelete = async (id: string) => {
    try {
      await DynamicModuleService.deleteItem(
        schemaEmployeeOnboardingTemplate ?? "",
        id
      );
      notify.success("Employee deleted");
      setSelectedRowKeys([]);
      await queryClient.invalidateQueries({
        queryKey: ["module-data", schemaEmployeeOnboardingTemplate],
      });
    } catch (error) {
      console.error("Delete error:", error);
      notify.error("Failed to delete employee");
    }
  };

  const handleEdit = (id: string) => {
    navigate("/hrms" + HRMSNavigationRoutes.EDIT_EMP_LIFECYCLE(id));
  };

  const columns: ProColumns<any>[] = [
    {
      title: "ID",
      dataIndex: "id",
      hidden: true,
    },

    {
      title: "Title",
      dataIndex: "title",
    },
    {
      title: "Designation",
      dataIndex: "designation",
      render: (_: any, record: any) => {
        return findLabel(designationOptions, record?.designation);
      },
    },

    {
      title: "Actions",
      width: 100,
      valueType: "option",
      render: (_, record) => [
        <CustomButton
          key="edit"
          icon={<Edit2 size={16} />}
          onClick={() => handleEdit(record.id)}
          type="text"
        />,
        <Popconfirm
          title="Are you sure you want to delete this employee?"
          onConfirm={() => handleDelete(record.id)}
          okText="Yes"
          key="delete"
          cancelText="No"
        >
          <CustomButton
            danger
            key="delete"
            icon={<Trash size={16} />}
            type="text"
          />
        </Popconfirm>,
      ],
    },
  ];

  const toolBarRender = () => [
    <CustomButton
      key="add"
      type="primary"
      icon={<Plus size={16} />}
      onClick={() => navigate("/hrms" + HRMSNavigationRoutes.ADD_EMP_LIFECYCLE)}
    >
      Add Employee Lifecycle
    </CustomButton>,
  ];
  return (
    <ConfigDynamicTable<any>
      columns={columns}
      selectedRowKeys={selectedRowKeys}
      setSelectedRowKeys={setSelectedRowKeys}
      rowKey="id"
      toolBarRender={toolBarRender}
      headerTitle="EmployeeLifecycle"
      tableName={schemaEmployeeOnboardingTemplate ?? ""}
      filter={{}}
    />
  );
};

export default EmployeeLifecycleListPage;
